<template lang="pug">
    include PressNote.pug
</template>

<script>
import { mapState } from 'vuex';

const mapTexts = {
    esreps: {
        title: "Nota de prensa:",
        text: "ESREPs se consolida como el único registro reconocido por la Confederación Internacional de Registros ICREPs.",
    },
    colreps: {
        title: "Nota de prensa:",
        text: "REPS Colombia se consolida como el único registro colombiano reconocido por el Registro Español de Profesionales del Ejercicio",
    },
};

export default {
    name: 'PressNote',
    computed: mapState([
        "context",
    ]),
    data() {
        return {
            title: null,
            text: null,
        };
    },
    created() {
        this.title = mapTexts[this.context].title;
        this.text = mapTexts[this.context].text;
    }
}

</script>

<style scoped lang="scss">
@import "./../../variables";
@import "./../../variables_colreps";

@import "PressNote";

.context-colreps {
    @import "PressNoteColreps";
}
</style>



// WEBPACK FOOTER //
// src/components/press_note/PressNote.vue